var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.53,
    height: 13.298144,
    viewBox: "94.47 182.955856 9.53 13.298144",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "CompositeLayer"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104 195.063v-5.957c0-.655-.536-1.191-1.191-1.191H95.66c-.655 0-1.191.536-1.191 1.191v5.957c0 .655.536 1.191 1.19 1.191h7.149c.655 0 1.191-.536 1.191-1.191Zm-3.574-2.978c0 .655-.536 1.19-1.191 1.19a1.195 1.195 0 0 1-1.192-1.19c0-.656.537-1.192 1.192-1.192.655 0 1.191.536 1.191 1.192Z",
    fill: "#8c919a",
    fillRule: "evenodd",
    "data-name": "Path 13897"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.213 189.913v-2.979a2.95 2.95 0 0 0-2.978-2.978 2.95 2.95 0 0 0-2.979 2.978v2.979",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 2,
    stroke: "#8c919a",
    fill: "transparent",
    "data-name": "Path 13878"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.f530dcbdabd3e90bf2a49067dbb850fb.svg";
export { ForwardRef as ReactComponent };